import qs from 'qs';

export const UTM_TRACKING = {
  utm_source: 'pinterest',
  utm_medium: 'tracking',
  utm_campaign: 'inline-img-share'
};

/**
 * appends utm_* tracking to passed url
 *
 * @export
 * @param {String} url URL on which to append tracking params
 * @returns {String} url with utm_* tracking params appended
 */
export function addTrackingParams(url) {
  return `${url}?${qs.stringify(UTM_TRACKING)}`;
}
